export let titles = [
	{"name" : "量子RAM級", "start" : 0, "end": 45},
	{"name" : "レジスタ級", "start": 45, "end": 60},
	{"name" : "キャッシュメモリ級", "start": 60, "end": 75},
	{"name" :"RAM級", "start" : 75, "end": 90},
	{"name" : "フラッシュメモリ級", "start": 90, "end": 105},
	{"name" : "ハードディスク級", "start": 105, "end": 120},
	{"name" : "光学ディスク級", "start": 120, "end": 135},
	{"name" :"フロッピーディスク級", "start": 135, "end": 150},
	{"name" :"磁気テープ級", "start": 150, "end": 165},
	{"name" : "パンチカード級", "start": 165, "end": 10000000000000}
];